import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import {
  NO_FLAG,
} from '@common/constants/sharedConstants';

import {
  yesNoFlagPropTypes,
} from '../../shared/propTypes';

import {
  showTagsModalForAddEdit,
  showTagsModalForDelete,
} from './store/actions';

import {
  categoriesOptionsSelector,
} from './store/selectors';

import {
  periodOrCurrentSelector,
} from '../../shared/store/selectors';

class CategoriesAndTagsAdminColumnRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.shape({
      tagName: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      isDeletable: yesNoFlagPropTypes,
    }).isRequired,

    showTagsModalForAddEdit: PropTypes.func.isRequired,
    showTagsModalForDelete: PropTypes.func.isRequired,

    node: PropTypes.shape({
      rowIndex: PropTypes.number.isRequired,
    }),
  };

  showTagsModalForEdit = () => {
    const { value, showTagsModalForAddEdit } = this.props;
    showTagsModalForAddEdit(value);
  };

  showTagsModalForDelete = () => {
    const { value, showTagsModalForDelete, node } = this.props;
    showTagsModalForDelete({ tagName: value.tagName, rowIndex: node.rowIndex });
  };

  render() {
    const { isDeletable } = this.props.value;
    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Tag"
          onClick={this.showTagsModalForEdit}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
        <button
          className="cell-icon-button"
          title="Delete Tag"
          onClick={this.showTagsModalForDelete}
          disabled={isDeletable === NO_FLAG}
        >
          <TrashIcon
            size={16}
            className="cell-icon disabled-visible"
            data-tip={isDeletable === NO_FLAG ? 'Tag is assigned to an Obligation' : ''}
          />
        </button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { administration } = state;
  return {
    category: administration.categoriesAndTags.category,
    period: periodOrCurrentSelector(state),
    categoriesOptions: categoriesOptionsSelector(state),
  };
}

export default connect(
  mapStateToProps,
  {
    showTagsModalForAddEdit,
    showTagsModalForDelete,
  }
)(CategoriesAndTagsAdminColumnRenderer);
